<template>
  <alert-card display="scroll-window" :primaryHeading="heading">
    <contact-event-details
      v-for="(event, index) in recentlyBookedEvents"
      :key="index"
      :event="event"
      :requests="['formatted-date', 'total']"
      class="overdue-invoice-list-item"
      @click="navigateToEvent(event)"
    />
  </alert-card>
</template>
<script>
import AlertCard from "../../../Components/UI/AlertCard.vue";
import ContactEventDetails from "../../../Components/UI/ListItems/Event/ContactEventDetails.vue";

// import { total, balanceOutstanding } from "../../../Helpers/invoice.js";

export default {
  data() {
    return {};
  },
  computed: {
    heading() {
      return `${this.recentlyBookedEvents.length} bookings in the past 30 days!`;
    },
    depositAmount() {
      if (this.$store.getters.depositType === "percentage") {
        return (
          this.$store.getters.depositAmount *
          0.01 *
          this.total(this.event.invoice, this.event.data)
        );
      } else {
        return this.$store.getters.depositAmount;
      }
    },
    recentlyBookedEvents() {
      let events = this.$store.getters.events();
      let getBookingDate = (event) => {
        let bookingTimeStamp = event.userId.split("event")[1];
        let now = Date.now();
        let month = 1000 * 60 * 60 * 24 * 30;
        return now - parseInt(bookingTimeStamp) < month;
      };
      return events
        .filter((x) => {
          return getBookingDate(x);
        })
        .sort((a, b) => {
          let startTime = (event) => {
            switch (event.api_version) {
              case "9-28-2022":
                return new Date(event.start_time).getTime();
              default:
                return new Date(event.data.startTime).getTime();
            }
          };
          let aStart = startTime(a);
          let bStart = startTime(b);
          return aStart < bStart ? -1 : aStart > bStart ? 1 : 0;
        });
    },
  },
  methods: {
    navigateToEvent(event) {
      this.$router.push(`/event/${event.tenantId}/${event.userId}`);
    },
  },
  created() {},
  components: { AlertCard, ContactEventDetails },
  props: [],
};
</script>
<style scoped>
.overdue-invoice-list-item {
  height: 40px;
  margin: 5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
